module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAAXNSR0IArs4c6QAAAP5JREFUKBWdkb2Kg1AQhY8/WFgEQQWxsbBJp43a2doJvoe+jg9jl04rwcLG0kbsRBAUJdm5YZs1ZHdzisswZ75hZi53/xI+EP8BwxAuy7K767r/4hVFgWhZFqZpQtu2MAwDjuOcmpB/u92Y7/s+VFUFRzvmeY4gCFAUBTzPO4HHcaAsSwakacp8kV66T1VVSJIEkiSdQErUdQ1RFEFNBEEAA8nY9x3X65XCl7JtG+u6ous6Vsdv24Z5nqFp2kvgOxlFEYZhQNM0LMXTUfq+BxnvdLlc2BrjOD5B6mCaJlv8HUieLMtYluUJ0uxhGP7GMD+OY+i6zmL2HX+ifhQ9AFYIWr2c8lEPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/comedor-mesa.png
// module id = 497
// module chunks = 0